<template>
    <div class="main">
        <div>
            <!-- 顶部banner -->
            <div class="topImg">
                <img src="@/assets/images/top_gift@2x.png" class="banner" />
                <img src="@/assets/images/left.png" class="returnPage" @click="hanldeReturn" />
            </div>
            <!-- 主要内容 -->
            <div class="information">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <!-- id -->
                    <el-form-item prop="id">
                        <div class="label">玩家ID:</div>
                        <el-input
                            v-model="ruleForm.id"
                            placeholder="请输入ID"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                            :disabled="isMail"
                        ></el-input>
                    </el-form-item>
                    <!-- redemption -->
                    <el-form-item prop="redemption">
                        <div class="label">兑换码:</div>
                        <el-input
                            v-model="ruleForm.redemption"
                            placeholder="请输入兑换码"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                            :disabled="isMail"
                        ></el-input>
                    </el-form-item>
                    <!-- 验证码 -->
                    <div v-show="!isMail">
                        <el-form-item prop="verification">
                            <div class="label">验证码:</div>
                            <div class="verify">
                                <el-input v-model="ruleForm.verification" placeholder="请输入验证码" id="verify" :disabled="isMail">
                                </el-input>
                                <div class="code">
                                    <img :src="verificationCode" alt="" @click="refresh" />
                                </div>
                            </div>
                        </el-form-item>
                    </div>

                    <!-- 点击按钮 -->
                    <el-form-item v-if="!bindShow">
                        <div class="exchange">
                            <div @click="submitForm" style="display: inline-block">
                                <img v-show="!isDisable" src="@/assets/images/redeem@2x.png" alt="" />
                                <img v-show="isDisable" src="@/assets/images/exchange.png" alt="" />
                            </div>
                        </div>
                    </el-form-item>
                    <div class="downloadMethod">
                        <div class="divWrap">
                            <div class="downloadWrap">
                                <a :href='iosDown'>
                                    <img src="@/assets/images/appstore@2x.png" alt=""
                                /></a>
                                <!-- <span>
                                    <img src="@/assets/images/androidbg@2x.png" alt="" class="android" />
                                    <b>敬请期待...</b>
                                </span> -->
                                <a :href='andDown'>
                                    <img src="@/assets/images/android@2x.png" alt="" class="android" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <el-form-item style="margin-top: 6.5rem">
                        <div class="label">兑换说明:</div>
                        <div style="font-size: 1.2rem; color: #aaadb7; text-align: left">
                            1、玩家ID可以在游戏内点击左上角设置按钮进行查看； <br />
                            2、成功兑换后请您登录游戏，在【邮件】中领取奖励；<br />
                            3、同一兑换码仅供同一玩家ID使用一次，无法重复使用。
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- footer -->
            <footer>
                <img src="@/assets/images/bird@2x.png" class="imgPosition" />
                <img src="@/assets/images/habby@2x.png" alt="" />
                <div>
                    抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
                    <p></p>
                    适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
                </div>
                <div>
                    适龄提示：适合8岁（含）以上玩家娱乐
                    <p></p>
                    Copyright@2021-2022 HabbyGames all rights reserved
                </div>
                <div>
                    审批文号：国新出审[2020]1376号
                    <p></p>
                    出版物号：ISBN 978-7-498-07853-7
                </div>
                <div>
                    出品单位：上海乐钻科技有限公司
                    <p></p>
                    联系电话：021-80270689
                </div>
                <div>
                    <a href="https://www.lezuan.net/server.html">游戏许可及服务协议</a> ｜<a
                        href="http://www.lezuan.net/termsOfSubscription.html"
                        >游戏隐私保护指引</a
                    >
                </div>
                <div>
                    京ICP备19032146号-1
                </div>
            </footer>
            <!-- 弹框 -->
            <div class="body" v-show="isModal">
                <div class="modal">
                    <div class="" style="flex: 1">
                        <!-- 输入信息确认 -->
                        <h4 v-if="!isMessage">ID:{{ ruleForm.id }}</h4>
                        <p v-if="!isMessage">您确定为此ID兑换奖励吗？</p>
                        <!-- 返回错误消息 -->
                        <p v-else>{{ message }}</p>
                    </div>

                    <div class="btnWrap">
                        <span @click="handleNo" :class="{ span: isNo }" v-show="!isMessage"> No </span>
                        <span @click="handleYes" :class="{ span: isYes }" v-show="!isMessage"> Yes </span>
                        <span @click="handleOk" :class="{ span: isOk }" class="spanOk" v-show="isMessage"> OK </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { myHTTP } from '@/utils/net'
import { lang } from '@/tool/lang'
import { urls } from '@/tool/url'

export default {
    data() {
        var validateId = (rule, value, callback) => {
            if (value === '') {
                callback('请输入ID！')
            } else {
                callback()
            }
        }
        var validateRedemption = (rule, value, callback) => {
            if (value === '') {
                callback('请输入兑换码！')
            } else {
                callback()
            }
        }
        var validateVerification = (rule, value, callback) => {
            if (value === '') {
                callback('请输入验证码！')
            } else {
                callback()
            }
        }
        return {
            iosDown: '',
            andDown: '',
            enMail: 'Check the rewards code in your email.',
            enBind: 'Your email address to redeem rewards is',
            bindMail: '',
            bindShow: false,
            isMail: false,
            isMessage: false,
            isModal: false,
            isNo: false,
            isYes: false,
            isClick: true,
            isOk: false,
            isNull: false,
            ruleForm: {
                id: '',
                redemption: '',
                verification: ''
            },
            rules: {
                id: [{ required: true, trigger: ['blur', 'change'], validator: validateId }],
                redemption: [{ required: true, trigger: ['blur', 'change'], validator: validateRedemption }],
                verification: [{ required: true, trigger: ['blur', 'change'], validator: validateVerification }]
            },
            newArr: [{}],
            verificationCode: '',
            captchaId: '',
            message: '',
            isOk: false,
            isDisable: false
        }
    },
    watch: {},
    created() {
        this.getId()
        this.getLang('zh-CN')
        this.iosDown = urls.ios;
        this.andDown = urls.and;
    },
    mounted() {
        document.documentElement.scrollTop = 0
    },
    methods: {
        hanldeReturn() {
            this.$emit('hanldeReturn')
            // // this.$router.push('/')
            // if (['localhost'].indexOf(location.hostname) >= 0) {
            //     window.location = 'https://test-danke.habby.cn/index.html'
            // } else if (['test'].indexOf(location.hostname) >= 0) {
            //     window.location = 'https://test-danke.habby.cn/index.html'
            // } else {
            //     window.location = 'https://danke.habby.cn/index.html'
            // }
        },
        getLang(language) {
            for (var i in lang) {
                this.newArr[0][i] = lang[i][language]
            }
        },
        submitForm() {
            if (this.isDisable === true) {
                return
            }

            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.isModal = true
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName][0].resetFields()
        },
        handleYes() {
            if (this.isMessage) {
                this.isMessage = false
            } else {
                this.claim()
                this.getId()
            }
            this.isYes = true
            this.isModal = false
            this.isYes = false
        },
        handleOk() {
            this.isOk = true
            this.isModal = false
            this.isOk = false
            this.isMessage = false
        },
        handleNo() {
            this.isMessage = false
            this.isNo = true
            this.isModal = false
            this.isNo = false
        },
        getId() {
            myHTTP.post('/api/v1/captcha/generate').then(res => {
                this.captchaId = res.data.data.captchaId
                myHTTP.get(`/api/v1/captcha/image/${res.data.data.captchaId}`).then(res => {
                    this.verificationCode = res.config.url
                    this.isClick = true
                })
            })
        },
        refresh() {
            if (this.isClick) {
                this.isClick = false
                this.getId()
            } else {
                return
            }
        },
        claim() {
            this.isDisable = true
            let aclaim = ''
            if (this.ruleForm.id.indexOf('-') !== -1) {
                // aclaim = this.ruleForm.id.replace(/\s/g, '').split('-')[1]
                aclaim = this.ruleForm.id.split('-')[1].replace(/^\s+|\s+$/gm, '')
            } else {
                // aclaim = this.ruleForm.id.replace(/\s/g, '')
                aclaim = this.ruleForm.id.replace(/^\s+|\s+$/gm, '')
            }
            myHTTP
                .post('/api/v1/giftcode/claim', {
                    userId: aclaim,
                    // giftCode: this.ruleForm.redemption.replace(/\s/g, ''),
                    // captcha: this.ruleForm.verification.replace(/\s/g, ''),
                    // captchaId: this.captchaId.replace(/\s/g, '')

                    giftCode: this.ruleForm.redemption.replace(/^\s+|\s+$/gm, ''),
                    captcha: this.ruleForm.verification.replace(/^\s+|\s+$/gm, ''),
                    captchaId: this.captchaId.replace(/^\s+|\s+$/gm, '')
                })
                .then(res => {
                    this.isDisable = false

                    this.isMessage = true
                    this.isModal = true
                    let code = res.data.code
                    if (code === 0) {
                        // this.isMail = true
                        // this.bindShow = true
                        this.message = this.newArr[0][20]
                    } else if (code === 20001) {
                        this.message = this.newArr[0][37]
                    } else if (code === 20002) {
                        this.message = this.newArr[0][38]
                    } else if (code === 20003) {
                        this.message = this.newArr[0][21]
                    } else if (code === 20401) {
                        this.message = this.newArr[0][22]
                    } else if (code === 20402) {
                        this.message = this.newArr[0][23]
                    } else if (code === 20403) {
                        this.message = this.newArr[0][24]
                    } else if (code === 20404) {
                        this.message = this.newArr[0][44]
                    } else if (code === 20409) {
                        this.message = '本兑换码已兑换完毕，无法再兑换。'
                    } else if (code === 20407) {
                        this.message = '该账号已领取过本活动的礼包。'
                    } else if (code === 20410) {
                        this.message = '非常抱歉，该礼包码是其他渠道的专属礼包码，您暂时无法领取。'
                    }else if (code === 30001) {
                        this.message = this.newArr[0][39]
                    } else {
                        this.message = this.newArr[0][39] + '(' + code + ')'
                    }
                })
        }
    }
}
</script>

<style scoped lang="less">
.main {
    width: 100%;
    overflow: hidden;
    position: relative;
    // font-family: 'CookieRunBlack';
    // font-family: 'CookieRunBold';
    // modal
    .body {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.42);
        .modal {
            line-height: 2.25rem;
            width: 35.625rem;
            height: 23.75rem;
            background: #ffffff;
            border-radius: 1.125rem;
            box-shadow: 0 0.5rem 3.375rem 0 #6e8eb8;
            padding: 4.9375rem 2.25rem 1.625rem;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            h4 {
                color: #ee8e35;
                font-size: 2.25rem;
                margin-bottom: 1.375rem;
            }
            p {
                font-size: 1.2rem;
                color: #151515;
            }
            .btnWrap {
                display: flex;
                justify-content: space-between;
                .spanOk {
                    margin: 0 auto;
                }
                span {
                    display: inline-block;
                    width: 45%;
                    font-size: 1.875rem;
                    line-height: 1.875rem;

                    border-radius: 0.701875rem;
                    border: 0.175625rem solid #ee8e35;
                    padding: 1.75rem 0;
                    color: #ee8e35;
                    cursor: pointer;
                }
                span:hover {
                    color: white;
                    background: #ee8e35;
                }
                .span {
                    color: white;
                    background: #ee8e35;
                }
            }
        }
    }
    // 顶部banner
    .topImg {
        text-align: center;
        overflow: hidden;
        position: relative;

        .banner {
            margin: 0 -100%;
            height: 19.375rem;
            z-index: 1;
        }
        .returnPage {
            position: absolute;
            left: 1.25rem;
            top: 1.25rem;
            z-index: 3;
            width: 2.25rem;
            cursor: pointer;
        }
        @media screen and (min-width: 768px) {
            .banner {
                width: 100%;
                height: auto;
            }
            .returnPage {
                cursor: pointer;
                position: absolute;
                left: 4.25rem;
                top: 4.25rem;
                z-index: 3;
                width: 3.75rem;
            }
        }
    }
    // 输入信息
    .information {
        display: inline-block;
        font-size: 1.2rem;
        line-height: 1.5rem;

        width: 37.5rem;
        max-width: 600px;
        /deep/.el-form-item {
            margin-top: 2.1875rem;
            // 输入框头部信息
            .label {
                font-size: 2.2rem;
                line-height: 2.5rem;

                text-align: left;
                padding: 1.25rem 0 1rem 1.375rem;
                color: #000000;
                span {
                    float: right;
                    color: #aaadb7;
                    font-size: 1.17rem;
                    img {
                        width: 0.975rem;
                    }
                }
            }
            // 验证码输入框
            .verify {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .el-input {
                    display: inline-block;
                    width: 26.875rem;
                    max-width: 430px;
                }
                #verify {
                    width: 26.875rem;
                    max-width: 430px;
                }
                .code {
                    flex: 1;
                    height: 4rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 1.25rem;
                    img {
                        cursor: pointer;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            // 绿色提示文案
            .gText {
                text-align: left;
                color: #52b46a;
                font-size: 1.2rem;
                line-height: 2.25rem;
                margin-left: 1.375rem;
                position: relative;
                img {
                    height: 17.75rem;
                    width: auto;
                    position: absolute;
                    top: 0;
                    right: -5.875rem;
                }
            }
            // mail上方带图片的文案
            .mailText {
                img {
                    height: 2.5rem;
                    vertical-align: center;
                }
                color: #1a1a1a;
                text-align: left;
                margin-left: 1.375rem;
                line-height: 2.5rem;
                font-size: 1.2rem;
                margin-bottom: 1.25rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box; //作为弹性伸缩盒子模型显示。
                -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
                -webkit-line-clamp: 2; //显示的行
            }
            .exchange {
                margin-top: 2.25rem;
                img {
                    height: auto;
                    width: 18.1875rem;
                    max-width: 291px;
                    cursor: pointer;
                }
            }
        }
        // 输入框
        /deep/input {
            text-align: center;
            height: 4.75rem;
            width: 37.5rem;
            max-width: 600px;
            max-height: 76px;
            border-radius: 2.38875rem;
            color: #aaadb7;
            font-size: 1.2rem;
            line-height: 1.5rem;

            box-shadow: 0 0.1875rem 0.1875rem 0 rgba(0, 0, 0, 0.42);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        // 错误信息
        /deep/.el-form-item__error {
            text-indent: 2.8125rem;
            color: #ff5565;
            font-size: 1.25rem;
        }
    }
    // 下载渠道
    .downloadMethod {
        text-align: center;
        .divWrap {
            display: inline-block;
            text-align: left;
            width: 100%;
            .downloadWrap {
                width: 100%;
                display: flex;
                justify-content: space-around;
                span {
                    position: relative;
                    display: inline-block;
                    b {
                        position: absolute;
                        color: #fff;
                        left: 38%;
                        bottom: 0.4rem;
                        font-size: 1.2rem;
                    }
                }
                margin-top: 1.25rem;
                // .android {
                //     margin: 0 2.8125rem;
                // }
                a {
                    width: 44%;
                }
                span {
                    width: 44%;
                }
                img {
                    width: 100%;
                }
                .twoCode {
                    // margin-left: 2.8125rem;
                    width: 10.25rem;
                }
                div {
                    margin-left: 1.25rem;
                    height: 6.25rem;
                    display: inline-block;
                    font-size: 1.25rem;
                }
            }
        }
    }
    // footer
    footer {
        position: relative;
        .imgPosition {
            width: 22.75rem;
            position: absolute;
            left: 5.25rem;
            top: -37.5rem;
        }
        padding: 4.375rem 0 6.25rem;
        background: #000000;
        color: #b3b3b3;
        img {
            width: 31.375rem;
        }
        a {
            color: #b3b3b3;
        }
        div {
            margin-top: 1.875rem;
        }
        p {
            display: none;
        }
    }
    @media screen and (max-width: 768px) {
        .imgPosition {
            display: none;
        }
        footer {
            padding: 4.375rem 0 2.9375rem;
            background: #080707;
            color: #757575;
            font-size: 1rem;
            img {
                width: 18.75rem;
            }
            a {
                color: #b3b3b3;
            }
            div {
                margin-top: 1.875rem;
            }
            p {
                display: block;
                height: 0.8rem;
            }
        }
    }
    // 展示信息
    .exhibit {
        margin: 0 auto;
        padding-bottom: 2.375rem;
        position: relative;
        width: 100%;
        max-width: 744px;
        h3 {
            color: #151515;
            font-size: 1.2rem;
            line-height: 1.5rem;

            margin-bottom: 1.1875rem;
        }
        img {
            display: inline-block;
            width: 27.375rem;
            max-width: 438px;
            border-radius: 0.5rem;
            margin-bottom: 3.125rem;
        }
        p {
            font-size: 1.125rem;
            color: #aaadb7;
            line-height: 1.125rem;

            margin: 1.875rem 0 1.25rem;
        }
        /deep/input {
            border-radius: 2.28125rem;
            color: #aaadb7;
            font-size: 1.17rem;
            line-height: 1.4625rem;
            text-align: center;

            height: 4.375rem;
            width: 13.75rem;
            max-height: 54px;
            max-width: 220px;
            box-sizing: content-box;
            padding: 0;
        }
        /deep/.el-input__prefix {
            display: flex;
            align-items: center;
            width: 1.875rem;
            font-size: 1.875rem;

            margin: 0 0.6rem;
            color: #aaadb7;
        }
        /deep/.el-input__icon {
            display: flex;
            align-items: center;
            width: 1.25rem;
            font-size: 1.25rem;

            margin: 0 0.6rem;
        }
        /deep/.el-select-dropdown__item {
            padding: 0;
        }
        .bottom_left {
            position: absolute;
            bottom: 0;
            left: -1rem;
            width: 12.8125rem;
            margin: 0;
        }
        .bottom_right {
            position: absolute;
            bottom: 0;
            right: -1rem;
            width: 13.375rem;
            margin: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/gift.vue